module.exports = __webpack_public_path__ + "static/teamMeeting-b1502091a400866b5030ffb8fbdf7a85.svg";